import { memo, FC, ReactNode } from 'react';

import resets from '../../_resets.module.css';
import classes from './SectionTitle.module.scss';

interface Props {
  className?: string;
  classes?: {
    root?: string;
    color?: string;
  };
  text?: string;
  children?: ReactNode; // 子要素を受け取るために追加
}

export const SectionTitle: FC<Props> = memo(function SectionTitle(props) {
  return (
    <h2 className={`${resets.clapyResets} ${props.classes?.root || ''} ${props.className || ''} ${classes.sectionTitle} ${props.classes?.color || ''}`}>
      {props.children || props.text || 'TITLE'}
    </h2>
  );
});



